import React from 'react'
import { string } from 'prop-types'

import {
  Icon,
  LockFilled,
  Close,
  WalletIcon,
  SuccessOutlined,
  SaleIcon,
  BookmarkAdd,
  UnfoldMore,
  ArrowRightUp,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function SvgTriangleUIIcon({
  type,
  ...rest
}) {
  function getIcon() {
    switch (type) {
      case 'lock':
        return LockFilled
      case 'close':
        return Close
      case 'wallet':
        return WalletIcon
      case 'successOutlined':
        return SuccessOutlined
      case 'sale':
        return SaleIcon
      case 'bookmarkAdd':
        return BookmarkAdd
      case 'unfoldMore':
        return UnfoldMore
      case 'arrowRightUp':
        return ArrowRightUp
      default:
        return null
    }
  }

  const IconComponent = getIcon()

  if (IconComponent) {
    return (
      <Icon notSpaced svgComponent={IconComponent} {...rest} />
    )
  }

  return null
}

SvgTriangleUIIcon.propTypes = {
  type: string.isRequired,
}

export default SvgTriangleUIIcon
